module.exports = __webpack_public_path__ + "static/fonts/element-icons.b02bdc1.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-default/fonts/element-icons.ttf?t=1472440741
// module id = 203
// module chunks = 26